import 'core-js/es/symbol';
import 'core-js/es/object';
import 'core-js/es/function';
import 'core-js/es/parse-int';
import 'core-js/es/parse-float';
import 'core-js/es/number';
import 'core-js/es/math';
import 'core-js/es/string';
import 'core-js/es/date';
import 'core-js/es/array';
import 'core-js/es/regexp';
import 'core-js/es/map';
import 'core-js/es/set';
import 'core-js/es/reflect';
import 'core-js/features/promise';

export class BrMCommon {

    static getTooltipOptions() {
        return {
            // Default tooltip placement relative to target element
            defaultPlacement: 'bottom',
            // Default CSS classes applied to the tooltip element
            defaultClass: 'vue-tooltip-theme',
            // Default CSS classes applied to the target element of the tooltip
            defaultTargetClass: 'has-tooltip',
            // Is the content HTML by default?
            defaultHtml: true,
            // Default HTML template of the tooltip element
            // It must include `tooltip-arrow` & `tooltip-inner` CSS classes (can be configured, see below)
            // Change if the classes conflict with other libraries (for example bootstrap)
            defaultTemplate: '<div class="tooltip" role="tooltip"><div class="tooltip-arrow"></div><div class="tooltip-inner"></div></div>',
            // Selector used to get the arrow element in the tooltip template
            defaultArrowSelector: '.tooltip-arrow, .tooltip__arrow',
            // Selector used to get the inner content element in the tooltip template
            defaultInnerSelector: '.tooltip-inner, .tooltip__inner',
            // Delay (ms)
            defaultDelay: (typeof APP_TOOLTIP_DELAY === 'undefined' || APP_TOOLTIP_DELAY === -1) ? 0 : { show: APP_TOOLTIP_DELAY * 1000, hide: 0 },
            // Default events that trigger the tooltip
            defaultTrigger: (typeof APP_TOOLTIP_DELAY === 'undefined' || APP_TOOLTIP_DELAY === -1) ? 'manual' : 'hover',
            // Default position offset (px)
            defaultOffset: 0,
            // Default container where the tooltip will be appended
            defaultContainer: 'body',
            defaultBoundariesElement: 'window',
            defaultPopperOptions: {},
            // Class added when content is loading
            defaultLoadingClass: 'tooltip-loading',
            // Displayed when tooltip content is loading
            defaultLoadingContent: 'Loading tooltip...',
            // Hide on mouseover tooltip
            autoHide: true,
            // Close tooltip on click on tooltip target?
            defaultHideOnTargetClick: true,
            // Auto destroy tooltip DOM nodes (ms)
            disposeTimeout: 5000,
            // Options for popover
            popover: {
                defaultPlacement: 'bottom',
                // Use the `popoverClass` prop for theming
                defaultClass: 'vue-popover-theme',
                // Base class (change if conflicts with other libraries)
                defaultBaseClass: 'tooltip popover',
                // Wrapper class (contains arrow and inner)
                defaultWrapperClass: 'wrapper',
                // Inner content class
                defaultInnerClass: 'tooltip-inner popover-inner',
                // Arrow class
                defaultArrowClass: 'tooltip-arrow popover-arrow',
                // Class added when popover is open
                defaultOpenClass: 'open',
                defaultDelay: 0,
                defaultTrigger: 'click',
                defaultOffset: 0,
                defaultContainer: 'body',
                defaultBoundariesElement: 'window',
                defaultPopperOptions: {},
                // Hides if clicked outside of popover
                defaultAutoHide: true,
                // Update popper on content resize
                defaultHandleResize: true,
            }
        };
    }

    static getUniqueComponentId(prefix) {
        let st = new Date();
        var t = new Date() - st,
            r = Math.floor(Math.random() * 1000),
            str;
        prefix = String(prefix) || '';
        str = '-' + t + '-' + r;
        return prefix + str;
    }

    static showWaitWheel(container, noRelPos, errorOnNull = true) {
        if (!container && errorOnNull) {
            console.error("Container is null");
            return;
        }

        if (!(noRelPos && noRelPos === true))
            $(container).css("position", "relative");

        $(container).prepend("<div class='overlay'><div class='overlay-spinner'></div></div>");
    }

    static hideWaitWheel(container, errorOnNull = true) {
        if (!container && errorOnNull) {
            console.error("Container is null");
            return;
        }

        $(container).find(".overlay").remove();
    }

    static hideSingleWaitWheel(container, errorOnNull = true) {
        if (!container && errorOnNull) {
            console.error("Container is null");
            return;
        }

        $(container).children(".overlay").remove();
    }

    static closestEl(el, tagName) {
        tagName = tagName.toLowerCase();

        while (el && el.parentNode) {
            el = el.parentNode;
            if (el.tagName && el.tagName.toLowerCase() === tagName) {
                return el;
            }
        }

        return null;
    }

    static getSortClass(col, sortedCol, sortDesc) {
        if (col !== sortedCol) {
            return 'fas fa-sort not-sorted text-light';
        } else if (sortDesc) {
            return 'fas fa-sort-amount-down text-light';
        } else {
            return 'fas fa-sort-amount-down-alt text-light';
        }
    }

    static cleanParamOptions(options, selectedValue) {
        let found = false;

        for (let x = 0; x < options.length; x++) {
            if (selectedValue === options[x].PARMVALUE) {
                found = true;
                if (!options[x].ISACTIVE) {
                    options[x].SHORTDESC += ' [inactive]';
                }
                break;
            }
        }

        if (!found) {
            options.unshift({ SHORTDESC: selectedValue + ' (FIX PARAM VALUES)', PARMVALUE: selectedValue, ISACTIVE: true });
        }
    }

    static isSelectedOptionInactive(options, selectedValue) {
        let inactive = false;

        for (let x = 0; x < options.length; x++) {
            if (selectedValue === options[x].PARMVALUE && !options[x].ISACTIVE) {
                inactive = true;
                break;
            }
        }

        return inactive;
    }

    static isSelectedOptionFixParam(options, selectedValue) {
        let fixParams = false;

        for (let x = 0; x < options.length; x++) {
            if (selectedValue === options[x].PARMVALUE && options[x].SHORTDESC !== null && options[x].SHORTDESC.indexOf('(FIX PARAM VALUES)') !== -1) {
                fixParams = true;
                break;
            }
        }

        return fixParams;
    }

    static preventMasterFormSubmit() {
        if (typeof jQuery !== 'undefined') {
            $("#aspnetForm").on("submit", function (e) { e.preventDefault(); });
        }
    }

    static onReady(callback) {
        if (callback && typeof callback === 'function') {
            if (!(BrMCommon.isIE && BrMCommon.browser.version < 11)) {
                document.addEventListener("DOMContentLoaded", function () {
                    return callback();
                });
            } else {
                document.attachEvent("onreadystatechange", function () {
                    if (document.readyState === "complete") {
                        return callback();
                    }
                });
            }
        } else {
            console.error('The callback is not a function!');
        }
    }

    static get isIE() {
        return BrMCommon.browser.isIE;
    }

    static get browser() {
        let browser = {
            isChrome: false,
            isMozilla: false,
            isOpera: false,
            isIE: false,
            isEdge: false,
            isSafari: false
        };
        var sUsrAg = navigator.userAgent;
        if (sUsrAg.indexOf("Chrome") > -1) {
            browser.isChrome = true;
        } else if (sUsrAg.indexOf("Safari") > -1) {
            browser.isSafari = true;
        } else if (sUsrAg.indexOf("Opera") > -1) {
            browser.isOpera = true;
        } else if (sUsrAg.indexOf("Firefox") > -1) {
            browser.isMozilla = true;
        } else if (sUsrAg.indexOf("Trident") > -1) { //I hate IE
            browser.isIE = true;
        }

        let ua = navigator.userAgent, tem, M = ua.match(/(opera|chrome|safari|firefox|msie|trident(?=\/))\/?\s*(\d+)/i) || [];
        if (/trident/i.test(M[1])) {
            tem = /\brv[ :]+(\d+)/g.exec(ua) || [];
            browser.name = 'IE';
            browser.version = parseInt((tem[1] || ''));
        }
        else if (M[1] === 'Chrome') {
            tem = ua.match(/\b(OPR|Edge)\/(\d+)/);
            if (tem !== null) {
                if (tem[1] === 'Edge')
                    browser.isEdge = true;
                browser.name = tem[1].replace('OPR', 'Opera');
                browser.version = parseInt(tem[2]);
            }
            else {
                M = M[2] ? [M[1], M[2]] : [navigator.appName, navigator.appVersion, '-?'];
                if ((tem = ua.match(/version\/(\d+)/i)) !== null)
                    M.splice(1, 1, tem[1]);

                browser.name = M[0];
                browser.version = parseInt(M[1]);
            }
        }
        else {
            M = M[2] ? [M[1], M[2]] : [navigator.appName, navigator.appVersion, '-?'];
            if ((tem = ua.match(/version\/(\d+)/i)) !== null)
                M.splice(1, 1, tem[1]);

            browser.name = M[0];
            browser.version = parseInt(M[1]);
        }

        //check cookies
        let cookieEnabled = navigator.cookieEnabled ? true : false;
        if (typeof navigator.cookieEnabled === "undefined" && !cookieEnabled) {
            document.cookie = "testcookie";
            cookieEnabled = document.cookie.indexOf("testcookie") !== -1 ? true : false;
        }
        browser.cookiesEnabled = cookieEnabled;

        return browser;
    }

    static getObjectsForCurrentListingPage(allObjects, currentPage, rowsPerPage) {
        if (IsNullOrUndefined(allObjects) || !Array.isArray(allObjects) || IsNullOrUndefined(currentPage) || isNaN(currentPage) || IsNullOrUndefined(rowsPerPage) || isNaN(rowsPerPage)) {
            return null;
        } else {
            //for sanity sake, here we parse the current page and rowsPerPage to an integer prior to any mathematical equations
            currentPage = parseInt(currentPage);
            rowsPerPage = parseInt(rowsPerPage);

            let maximumArrayIndex = allObjects.length - 1;

            let currentFirstRowIndex = (currentPage * rowsPerPage) - rowsPerPage;
            if (currentFirstRowIndex > maximumArrayIndex) {
                return null;
            } else {
                let currentLastRowIndex = currentPage * rowsPerPage;

                let objectsInPage = [];
                if (currentLastRowIndex > maximumArrayIndex) {
                    objectsInPage = allObjects.slice(currentFirstRowIndex);
                } else {
                    objectsInPage = allObjects.slice(currentFirstRowIndex, currentLastRowIndex);
                }

                return objectsInPage;
            }
        }
    }

    static getCleanObjectFromVue(obj) {
        return JSON.parse(JSON.stringify(obj));
    }

    static watchDOM(el, callback, attributes) {
        attributes = attributes || false;
        // Find the element that you want to "watch"
        if (el !== null) {
            // create an observer instance
            var observer = new MutationObserver(function (mutation) {
                if (typeof callback === 'function') {
                    callback(mutation);
                }
                else
                    throw 'callback not specified';
            });
            var config = { attributes: attributes };
            observer.observe(el, config);
        }
        else
            throw 'el not specified';

        return function () { observer.disconnect(); };
    }

    static getCookie(name) {
        var parts = document.cookie.split(name + "=");
        if (parts.length == 2) return parts.pop().split(";").shift();
    }
    static deleteCookie(name) {
        //var domain = window.location.hostname;
        document.cookie = name + "=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT" //remove cookie
    }

    static isThumbnailSupported(fileExtension) {
        switch (fileExtension.toLowerCase()) {
            case "bmp":
            case "gif":
            case "jpg":
            case "jpeg":
            case "png":
            case "jfif":
                return true;
            default:
                return false;
        }
    }

    static getFileExtension(fileName) {
        let lastIndexOfDot = fileName.lastIndexOf(".");
        let fileExtension = "";
        if (lastIndexOfDot > -1) {
          fileExtension = fileName.substring(lastIndexOfDot + 1);
        }

        return fileExtension;
    }

    static getFontAwesomeFileClass(fileExtension) {
        switch (fileExtension.toLowerCase()) {
            case "doc":
            case "docx":
                return "fas fa-file-word";
            case "csv":
                return "fas fa-file-csv";
            case "jpeg":
            case "png":
            case "jpg":
            case "jfif":
            case "gif":
            case "tiff":
                return "fas fa-file-image";
            case "xlsx":
            case "xls":
                return "fas fa-file-excel";
            case "pdf":
                return "fas fa-file-pdf";
            case "mov":
            case "mp4":
            case "avi":
            case "mpeg":
                return "fas fa-file-video";
            case "ppt":
            case "pptx":
                return "fas fa-file-powerpoint";
            case "mp3":
            case "wav":
                return "fas fa-file-audio";
            case "zip":
                return "fas fa-file-archive";
            default:
                return "fas fa-file-alt";
        }
    }

    static getBootstrapFileColorClass(fileExtension) {
        switch (fileExtension.toLowerCase()) {
            case "doc":
            case "docx":
                return "primary";
            case "jpeg":
            case "png":
            case "jpg":
            case "jfif":
            case "gif":
            case "tiff":
            case "mov":
            case "mp4":
                return "dark";
            case "csv":
            case "xlsx":
            case "xls":
                return "success";
            case "pdf":
                return "danger";
            case "ppt":
            case "pptx":
                return "orange";
            default:
                return "dark";
        }
    }

    // See: https://stackoverflow.com/questions/16086162/handle-file-download-from-ajax-post/23797348#23797348
    //You can use this function to download a file using ajax post.
    //It returns a promise that will resolve after file is downloaded and reject if status from controller is not 200
    static downloadFileAjaxPost(url, data) {
        return new Promise(function (resolve, reject) {
            var xhr = new XMLHttpRequest();
            xhr.open('POST', url, true);
            xhr.responseType = 'arraybuffer';
            xhr.onload = function () {
                if (this.status === 200) {
                    var filename = "";
                    var disposition = xhr.getResponseHeader('Content-Disposition');
                    if (disposition && disposition.indexOf('attachment') !== -1) {
                        var filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
                        var matches = filenameRegex.exec(disposition);
                        if (matches != null && matches[1]) filename = matches[1].replace(/['"]/g, '');
                    }
                    var type = xhr.getResponseHeader('Content-Type');

                    var blob;
                    if (typeof File === 'function') {
                        try {
                            blob = new File([this.response], filename, { type: type });
                        } catch (e) { /* Edge */ }
                    }
                    if (typeof blob === 'undefined') {
                        blob = new Blob([this.response], { type: type });
                    }

                    if (typeof window.navigator.msSaveBlob !== 'undefined') {
                        // IE workaround for "HTML7007: One or more blob URLs were revoked by closing the blob for which they were created. These URLs will no longer resolve as the data backing the URL has been freed."
                        window.navigator.msSaveBlob(blob, filename);
                    } else {
                        var URL = window.URL || window.webkitURL;
                        var downloadUrl = URL.createObjectURL(blob);

                        if (filename) {
                            // use HTML5 a[download] attribute to specify filename
                            var a = document.createElement("a");
                            // safari doesn't support this yet
                            if (typeof a.download === 'undefined') {
                                window.location.href = downloadUrl;
                            } else {
                                a.href = downloadUrl;
                                a.download = filename;
                                document.body.appendChild(a);
                                a.click();
                            }
                        } else {
                            window.location.href = downloadUrl;
                        }

                        setTimeout(function () { URL.revokeObjectURL(downloadUrl); }, 100); // cleanup
                    }
                    resolve();
                } else {
                    reject();
                }
            };

            xhr.setRequestHeader('Content-type', 'application/json');
            xhr.send(JSON.stringify(data));
        });
    }

    static htmlDecode(input) {
        var doc = new DOMParser().parseFromString(input, "text/html");
        return doc.documentElement.textContent;
    }

    static removeUrlQueryParam(paramName) {
        if (!paramName) throw "'paramName' must be specified!";
        const params = new URLSearchParams(window.location.search);
        params.delete(paramName);
        window.location.search = params.toString();
    }

    static getUrlQueryParam(paramName) {
        if (!paramName) throw "'paramName' must be specified!";
        const params = new URLSearchParams(window.location.search);
        return params.get(paramName);
    }

    static get isPageDirty() {
        return document.getElementsByClassName("dirtyBar").length > 0;
    }

    static getFileSizeInMb(bytes) {
        if (IsNullOrUndefined(bytes)) {
            return "";
        }
        // 1MB = 1024 * 1024
        const oneMegaByte = 1048576;
        return Math.floor(bytes / oneMegaByte);
    }

    static formatMegaBytes(megaBytes) {
        if (IsNullOrUndefined(megaBytes)) {
            return "";
        }
        else if (megaBytes < 1) {
            return "< 1 MB";
        } else {
            return megaBytes.toLocaleString("en-US").replace(/\B(?=(\d{3})+(?!\d))/g, ",") + " MB";
        }
    }

    static formatBytesToMb(bytes) {
        return BrMCommon.formatMegaBytes(BrMCommon.getFileSizeInMb(bytes));
    }
    
    static fieldTextString(field) {
        return field?.toString() ?? "";
    }
}

export default BrMCommon;

window.MutationObserver = window.MutationObserver || window.WebKitMutationObserver || window.MozMutationObserver;

window.addEventListener('unhandledrejection', function (event) {
    if (!window.prErrorCount)
        window.prErrorCount = 0;
    let message = event.reason.message;
    if (typeof AddValidationMessage === 'function')
        AddValidationMessage('PROMISEREJECTION' + window.prErrorCount++, message, 'ERROR');
    else
        alert(message);

    console.error(event);
});


//Pollyfill (sortof) for IE's Object.keys behaving differently than the other browsers.
try {
    Object.keys(false);
}
catch{
    Object.keys = function (o, k, r) { r = []; for (k in o) r.hasOwnProperty.call(o, k) && r.push(k); return r; };
}

/* IE includes polyfill */
if (!Array.prototype.includes) {
    //or use Object.defineProperty
    Array.prototype.includes = function (search) {
        return !!~this.indexOf(search);
    };
}

if (!String.prototype.includes) {
    String.prototype.includes = function () {
        'use strict';
        return String.prototype.indexOf.apply(this, arguments) !== -1;
    };
}

/* IE remove polyfill */
if (!Element.prototype.remove) {
    Element.prototype.remove = function () {
        if (this.parentNode) {
            this.parentNode.removeChild(this);
        }
    };
}


